var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("header", { staticClass: "dialog__header" }, [
            _c(
              "h2",
              { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingFishConfirmDialog.title")) +
                    " "
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "dialog__body" }, [
            _c("p", { staticClass: "dialog__lead" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("proofreadingFishConfirmDialog.lead")) + " "
              ),
            ]),
            _c("div", { ref: "calcWrap", staticClass: "dialog__calc" }, [
              _c(
                "button",
                {
                  staticClass: "dialog__calc-link",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.isCalcTipOpen ? "true" : "false",
                    "aria-controls": _vm.calcTipId,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onToggleCalcTip.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("IconInfo"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("proofreadingFishConfirmDialog.calcLink")) +
                      " "
                  ),
                ],
                1
              ),
              _vm.isCalcTipOpen
                ? _c(
                    "div",
                    {
                      staticClass: "dialog__calc-tip",
                      attrs: { id: _vm.calcTipId, role: "tooltip" },
                    },
                    [
                      _c("p", { staticClass: "dialog__calc-tip-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "proofreadingFishConfirmDialog.calcTipTitle"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "ul",
                        { staticClass: "dialog__calc-tip-list" },
                        _vm._l(_vm.tierRows, function (row, index) {
                          return _c(
                            "li",
                            { key: index, staticClass: "dialog__calc-tip-row" },
                            [
                              _c(
                                "span",
                                { staticClass: "dialog__calc-tip-range" },
                                [_vm._v(_vm._s(row.range))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "dialog__calc-tip-sep",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [_vm._v("：")]
                              ),
                              _c(
                                "span",
                                { staticClass: "dialog__calc-tip-amount" },
                                [_vm._v(_vm._s(row.amount))]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.isSessionContinuation
                        ? _c("p", { staticClass: "dialog__calc-tip-note" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "proofreadingFishConfirmDialog.sessionNote"
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "p",
              { staticClass: "dialog__cost" },
              [
                _c("i18n", { attrs: { path: _vm.costI18nPath, tag: "span" } }, [
                  _c(
                    "strong",
                    {
                      staticClass: "dialog__cost-amount",
                      attrs: { place: "amount" },
                    },
                    [_vm._v(_vm._s(_vm.formattedAmount) + " fish")]
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "dialog__cancel-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickCancel },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingFishConfirmDialog.cancel")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__ok-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickConfirm },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingFishConfirmDialog.confirm")) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }